import { getCharacterCount } from './contentOverflowPlugin';
import { parseBannerContent } from './parseBannerContent';
import type { AdfNode } from './contentOverflowPlugin';
import { getLinks } from './getLinks';
import { getEmojis } from './getEmojis';
import type { MutationType, MutationUpdateReason } from './AABForm/AABFormConstants';
import { ConfluenceAdminAnnouncementBannerStatusType } from './queries/__types__/UpdateAdminAnnouncementBannerMutation';

export enum MutationStatus {
	ERROR = 'errored',
	SUCCESS = 'succeeded',
}

export type GetMutationAnalyticsEventPayloadProps = {
	mutationType: MutationType;
	updateReason?: MutationUpdateReason;
	mutationStatus: MutationStatus;
	data?: any;
};

export const getMutationAnalyticsEventPayload = ({
	mutationType,
	mutationStatus,
	data,
	updateReason,
}: GetMutationAnalyticsEventPayloadProps) => {
	const content = parseBannerContent(data?.content);
	const isScheduled = data?.status === ConfluenceAdminAnnouncementBannerStatusType.SCHEDULED;

	const attributes = {
		...(mutationType === 'update' && { updateReason }),

		...(mutationStatus === MutationStatus.ERROR
			? { errorMessage: data }
			: {
					messageCharCount: getCharacterCount(content.content as AdfNode[]),
					bannerStatus: data?.status?.toLowerCase(),
					bannerId: data?.id,
					linkCount: getLinks(content).length,
					emojiCount: getEmojis(content).length,
					appearance: data?.appearance,
					dismissable: data?.isDismissible,
					audience: data?.visibility?.toLowerCase(),
					isScheduled,
				}),
	};

	return {
		type: 'sendTrackEvent',
		data: {
			source: 'adminAnnouncementBannerSettingsPage',
			actionSubject: `${mutationType}AdminAnnouncementBannerMutation`,
			action: mutationStatus,
			attributes,
		},
	};
};
